import { useQuery } from "@tanstack/react-query";
import { SessionService } from "@/services/brain/SessionService";

export const useUnlinkedInvocations = (userId: string | null) => {
  return useQuery({
    queryKey: ["brain", "unlinked-invocations", userId],
    queryFn: () => SessionService.getUnlinkedInvocations(userId as string),
    enabled: !!userId,
    staleTime: 30 * 1000,
  });
};
